import { getData, postData, putData, deleteData } from "../apiClient";

// ─── Paginated list ───────────────────────────────────────────────────────────

export const getBlogTagsWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({ page: String(page), limit: String(limit), search });
        const result = await getData(`/blog-tag/?${queryParams}`, {}, {}, signal);
        return { success: true, ...result };
    } catch (error) {
        console.error("Get Blog Tags pagination API error:", error);
        return { success: false, ...error };
    }
};

// ─── Dropdown (no pagination) ─────────────────────────────────────────────────

export const getBlogTagDropdown = async () => {
    try {
        const result = await getData(`/blog-tag/dropdown`);
        return { data: { success: true, ...result } };
    } catch (error) {
        console.error("Get Blog Tag dropdown API error:", error);
        return { data: { success: false, error: error.message } };
    }
};

// ─── Single record ────────────────────────────────────────────────────────────

export const getBlogTagById = async (id) => {
    try {
        const result = await getData(`/blog-tag/${id}`);
        return { data: { success: true, ...result } };
    } catch (error) {
        return { data: { success: false, error: error.message } };
    }
};

// ─── Create ───────────────────────────────────────────────────────────────────

export const createBlogTag = async ({ data }) => {
    try {
        const result = await postData(`/blog-tag/create-tag`, data);
        return { data: { success: true, data: result } };
    } catch (error) {
        return { data: { success: false, error: error.status === 400 ? error.data?.error : error.message, status: error.status } };
    }
};

// ─── Update ───────────────────────────────────────────────────────────────────

export const updateBlogTag = async ({ id, data }) => {
    try {
        const result = await putData(`/blog-tag/update-tag/${id}`, data);
        return { data: { success: true, data: result } };
    } catch (error) {
        return { data: { success: false, error: error.status === 400 ? error.data?.error : error.message, status: error.status } };
    }
};

// ─── Delete ───────────────────────────────────────────────────────────────────

export const deleteBlogTag = async ({ id }) => {
    try {
        const result = await deleteData(`/blog-tag/delete-tag/${id}`);
        return { data: { success: true, data: result } };
    } catch (error) {
        return { data: { success: false, error: error.message, status: error.status } };
    }
};
